module.exports = __webpack_public_path__ + "img/block33.85c49daa.jpg";